import { render, staticRenderFns } from "./Interviews.vue?vue&type=template&id=84c77104&"
import script from "./Interviews.vue?vue&type=script&lang=js&"
export * from "./Interviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports